import { ProtectedArea } from '@/components/ProtectedArea';
import { lazy } from 'react';
import { Outlet } from 'react-router-dom';
import {
  ADMIN_ROUTE,
  SCREEN_CONTROL_ROUTE,
  SCREEN_MODERATION_ROUTE,
  SCREEN_ENGAGEMENT_ROUTE,
  SCREEN_ROUTE,
  SCREENS_ROUTE,
  USERS_ROUTE,
  LOGIN_ROUTE,
  SCREEN_CONFIG_ROUTE,
  SCREEN_EDITOR_ROUTE,
  SCREEN_INSIGHTS_ROUTE,
  SCREEN_ENGAGEMENTS_ROUTE,
  TEMPLATES_ROUTE,
  DB_ROUTE,
  BETA_SIGNUPS_ROUTE,
} from '../consts';
import { RedirectWithParams } from '@/components/RedirectWithParams';
import { ScreenAdminContainer } from '@/routes/admin/screen/ScreenAdminContainer';

// Lazy load admin components
const AdminHome = lazy(() => import('@/routes/admin/home'));
const AdminUsersPage = lazy(() => import('./users/AdminUsersPage'));
const AdminTemplatesPage = lazy(() => import('./templates/AdminTemplatesPage'));
const AdminScreens = lazy(() => import('@/routes/admin/screens'));
const AdminScreenEngagementsPage = lazy(
  () => import('@/routes/admin/screen/engagements/engagements'),
);
const AdminScreenControlPage = lazy(
  () => import('@/routes/admin/screen/control/control'),
);
const AdminScreenEngagementPage = lazy(
  () => import('@/routes/admin/screen/engagements/engagement/engagement'),
);
const AdminDbPage = lazy(() => import('@/routes/admin/db'));
const AdminBetaSignupsPage = lazy(
  () => import('@/routes/admin/beta-signups/AdminBetaSignupsPage'),
);

const AdminScreenConfigPage = lazy(
  () => import('@/routes/admin/screen/config'),
);
const AdminScreenEditorPage = lazy(
  () => import('@/routes/admin/screen/editor/editor'),
);
const AdminScreenInsightsPage = lazy(
  () => import('@/routes/admin/screen/insights'),
);
const AdminScreenModerationPage = lazy(
  () => import('@/routes/admin/screen/moderation/moderation'),
);
const BanUiPreviewPage = lazy(
  () => import('@/routes/admin/screen/moderation/BanUiPreview'),
);

export const superAdminRoutes = {
  element: (
    <ProtectedArea
      roles={['ADMIN']}
      redirectTo={`${LOGIN_ROUTE}?redirect=$path`}
    >
      <Outlet />
    </ProtectedArea>
  ),
  children: [
    {
      path: USERS_ROUTE,
      element: <AdminUsersPage />,
    },
    {
      path: TEMPLATES_ROUTE,
      element: <AdminTemplatesPage />,
    },
    {
      path: DB_ROUTE,
      element: <AdminDbPage />,
    },
    {
      path: BETA_SIGNUPS_ROUTE,
      element: <AdminBetaSignupsPage />,
    },
  ],
};

export const adminRoutes = {
  element: (
    <ProtectedArea
      roles={['ADMIN', 'USER']}
      redirectTo={`${LOGIN_ROUTE}?redirect=$path`}
    >
      <Outlet />
    </ProtectedArea>
  ),
  children: [
    {
      path: ADMIN_ROUTE,
      element: <AdminHome />,
    },
    {
      path: SCREENS_ROUTE,
      element: <AdminScreens />,
    },
    {
      path: SCREEN_ROUTE,
      element: (
        <RedirectWithParams to={SCREEN_EDITOR_ROUTE} paramKeys={['id']} />
      ),
    },
    {
      path: SCREEN_EDITOR_ROUTE,
      element: (
        <ScreenAdminContainer section="editor">
          <AdminScreenEditorPage />
        </ScreenAdminContainer>
      ),
    },
    {
      path: SCREEN_ENGAGEMENTS_ROUTE,
      element: (
        <ScreenAdminContainer section="engagements">
          <AdminScreenEngagementsPage />
        </ScreenAdminContainer>
      ),
    },
    {
      path: SCREEN_ENGAGEMENT_ROUTE,
      element: (
        <ScreenAdminContainer section="editor">
          <AdminScreenEngagementPage />
        </ScreenAdminContainer>
      ),
    },
    {
      path: SCREEN_CONTROL_ROUTE,
      element: (
        <ScreenAdminContainer section="control">
          <AdminScreenControlPage />
        </ScreenAdminContainer>
      ),
    },
    {
      path: `${ADMIN_ROUTE}/ban-ui-preview`,
      element: <BanUiPreviewPage />,
    },
    {
      path: SCREEN_MODERATION_ROUTE,
      element: (
        <ScreenAdminContainer section="moderation">
          <AdminScreenModerationPage />
        </ScreenAdminContainer>
      ),
    },
    {
      path: SCREEN_CONFIG_ROUTE,
      element: (
        <ScreenAdminContainer section="settings">
          <AdminScreenConfigPage />
        </ScreenAdminContainer>
      ),
    },
    {
      path: SCREEN_INSIGHTS_ROUTE,
      element: (
        <ScreenAdminContainer section="insights">
          <AdminScreenInsightsPage />
        </ScreenAdminContainer>
      ),
    },
  ],
};
